<!-- fixme: create a custom stylable select component -->
<!-- important: Do not remove #select, required for viewChild -->
<select
  #select
  class="cursor-pointer focus:outline-none w-full mb-2 text-sm text-gray-600"
  (change)="onChange($event)"
  [value]="operatorSelectValue()"
>
  @for (operator of _operators(); track operator) {
    <option [value]="operator">
      {{ filterOperatorLabels[operator] }}
    </option>
    @if (_notOperators().includes(operator)) {
      <option [value]="FilterSuffix.NOT + ':' + operator">
        {{ filterOperatorNotLabels[operator] }}
      </option>
    }
  }
</select>
